import { Box, Drawer, SxProps, useTheme } from '@mui/material';
import * as Preact from 'preact';
import * as CtaCombo from './M_CtaCombo';
import { RETURN_TO_STORE_HEIGHT } from './M_ReturnToStoreBanner';
import * as ModalActionBar from './O_Modal/M_ModalActionBar';
import * as ModalTitle from './O_Modal/M_ModalTitle';
import { isSmallScreen } from './domain/theme/breakpoints';

export interface Props {
    onCloseClick: () => void;
    title: string;
    open: boolean;
    sx: SxProps;
    children: Preact.ComponentChild;
    actionBar?: {
        primary: CtaCombo.Action;
        secondary?: CtaCombo.Action;
    };
}

export const Component = (p: Props) => {
    const theme = useTheme();
    return isSmallScreen(useTheme()) ? (
        <Drawer
            anchor={'bottom'}
            open={p.open}
            PaperProps={{ sx: { borderRadius: '10px 10px 0px 0px' } }}
            onClose={p.onCloseClick}
            sx={{ maxHeight: `calc(100% - ${RETURN_TO_STORE_HEIGHT})`, height: 'max-content' }}
        >
            <ModalTitle.Component title={p.title} onCloseClick={p.onCloseClick} />
            {p.children}
            {p.actionBar && (
                <ModalActionBar.Component
                    primary={p.actionBar.primary}
                    secondary={p.actionBar.secondary}
                />
            )}
        </Drawer>
    ) : (
        <>
            {/* This box acts as an invisible backdrop so clicking on the scene will close the modals, whilst still enabling the action buttons to be clicked */}
            <Box
                zIndex={theme.zIndex.appBar - 1}
                height="100%"
                width="calc(100% - 72px)"
                position="fixed"
                sx={{ opacity: 0 }}
                display={p.open ? '' : 'none'}
                onClick={p.onCloseClick}
            />
            <Box
                minWidth="302px"
                borderRadius="10px"
                overflow="hidden"
                bgcolor="background.paper"
                position="absolute"
                zIndex="modal"
                display={p.open ? '' : 'none'}
                sx={p.sx}
            >
                <ModalTitle.Component title={p.title} onCloseClick={p.onCloseClick} />
                {p.children}
                {p.actionBar && (
                    <ModalActionBar.Component
                        primary={p.actionBar.primary}
                        secondary={p.actionBar.secondary}
                    />
                )}
            </Box>
        </>
    );
};

Component.displayName = 'ActionBarModal';
